import { RadioboxMarkedIcon } from './RadioboxMarkedIcon';

/**
 * author: Google
 * id BA101E5E-CDA9-45AA-B249-BD176AF11D95
 * name radiobox-marked
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiobox-marked.svg
 * tags
 * - Form 
 */
export const RadioButtonCheckedIcon = RadioboxMarkedIcon;
export default RadioButtonCheckedIcon